module.exports = __webpack_public_path__ + "img/logo-lxc.6a9393a3.png";